module.exports = __webpack_public_path__ + "img/specialite.9b869448.svg";